import React, { useEffect, useState } from "react";
import { api, extractApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Headphones, Check, Loader2 } from "lucide-react";
import { SERVICE_TIERS } from "../../lib/serviceTiers";

export default function SolunaryServicesCard({ t }) {
  const [interests, setInterests] = useState([]);
  const [busy, setBusy] = useState(null);

  const load = () => api.get("/tenant/solunary-services").then((r) => setInterests(r.data.interests || [])).catch(() => {});
  useEffect(() => { load(); }, []);

  const interestedTiers = new Set(interests.map((i) => i.tier));

  const express = async (tier) => {
    setBusy(tier);
    try {
      await api.post("/tenant/solunary-services/interest", { tier });
      toast.success(t("bill.services.thanks"));
      load();
    } catch (e) { toast.error(extractApiError(e, t("bill.error"))); }
    finally { setBusy(null); }
  };

  return (
    <div data-testid="solunary-services-card" className="bg-white rounded-2xl border border-eh-border-soft p-6">
      <div className="flex items-center gap-2 mb-1">
        <Headphones className="w-5 h-5 text-sol-gold" />
        <h2 className="font-display text-xl text-eh-ink">{t("bill.services.title")}</h2>
      </div>
      <p className="text-sm text-eh-muted mb-5">{t("bill.services.subtitle")}</p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {SERVICE_TIERS.map((tier) => {
          const opted = interestedTiers.has(tier.id);
          return (
            <div key={tier.id} data-testid={`service-tier-${tier.id}`} className="border border-eh-border-soft rounded-xl p-4 flex flex-col">
              <div className="font-sol font-semibold text-eh-ink">{tier.name}</div>
              <p className="text-xs text-eh-muted mt-1 flex-1">{t(`bill.services.${tier.id}.desc`)}</p>
              {opted ? (
                <div className="mt-3 inline-flex items-center gap-1 text-xs text-eh-sage-deep font-medium" data-testid={`service-opted-${tier.id}`}>
                  <Check className="w-3.5 h-3.5" /> {t("bill.services.interestSent")}
                </div>
              ) : (
                <Button size="sm" variant="outline" disabled={busy === tier.id} onClick={() => express(tier.id)}
                  data-testid={`service-contact-${tier.id}`} className="mt-3">
                  {busy === tier.id ? <Loader2 className="w-3.5 h-3.5 animate-spin mr-1" /> : null} {t("bill.services.contactUs")}
                </Button>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
